// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { useAuth } from "./context/AuthContext";

import Sidebar from "./components/Sidebar";
import LanguageSwitcher from "./components/LanguageSwitcher";

import Hydra from "./pages/Hydra";
import Meley from "./pages/Meley";
import Guild from "./pages/Guild";
import Timers from "./pages/Timers";
import Settings from "./pages/Settings";

import ProtectedRoute from "./routes/ProtectedRoute";
import Locked from "./pages/Locked";

export default function App() {
  const { user } = useAuth();

  return (
    <Router>
      {/* ============================================
          Dacă NU e logat → arată DOAR pagina Locked
      ============================================ */}
      {!user ? (
        <Locked />
      ) : (
        <>
          {/* Sidebar vizibil doar dacă userul este logat */}
          <Sidebar />

          <div className="ml-64 min-h-screen bg-[#151515] text-white relative">
            <LanguageSwitcher />

            <Routes>
              <Route path="/" element={<Hydra />} />
              <Route path="/meley" element={<Meley />} />
              <Route path="/guild" element={<Guild />} />
              <Route path="/timers" element={<Timers />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </div>
        </>
      )}
    </Router>
  );
}
